// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course .certHolder {
  padding-top: 45px;
}

.course .certHolder .col-md-12 {
  background-color: #1eabe3;
  height: 400px;
  margin-bottom: 300px;
}

.course .certHolder .col-md-12 .col-md-4 {
  margin-top: 120px;
}

.course .certHolder .col-md-12 .col-md-4 h2 {
  color: #fff;
  font-weight: bold;
}

.certInfo {
  border: 7px solid #000;
  float: right;
  margin: 15px 0px;
  padding: 0px;
  position: relative;
}

.certInfo img {
  width: 100%;
}

.certInfo span {
  position: absolute;
}

.certInfo .name {
  color: #228fc3;
  font-size: 45px;
  left: 0px;
  text-align: center;
  top: 39%;
  width: 100%;
}

.certInfo .courseName {
  font-size: 20px;
  left: 0px;
  text-align: center;
  top: 55%;
  width: 100%;
}

.certInfo .completionDate {
  width: 42%;
  bottom: 22%;
  color: #228fc3;
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  left: 0px;
}

.certInfo .score {
  text-align: center;
  bottom: 20%;
  color: #228fc3;
  font-size: 60px;
  font-style: normal;
  right: 0px;
  width: 42%;
}

.courseCertNMLS .name {
  font-size: 20px !important;
  top: 82% !important;
}

.courseCertNMLS .courseName {
  font-size: 30px !important;
  top: 54% !important;
  color: #228fc3;
}

.courseCertNMLS .completionDate {
  font-size: 20px !important;
  top: 82% !important;
  font-weight: normal;
}

.courseCertNMLS .nmlsID {
  font-size: 20px;
  top: 82%;
  color: #228fc3;
  left: 250px;
  text-align: center;
  width: 100%;
}

.courseCertNMLS .courseCode {
  font-size: 20px;
  top: 70%;
  color: #228fc3;
  left: 0px;
  text-align: center;
  width: 100%;
}

.certInfoView {
  color: #000;
  max-width: 1500px;
}

.certInfoView .header {
  margin: 2% auto 10% auto;
}

.certInfoView .seperator ~ .description {
  font-size: 0.9em;
  text-align: left;
  margin-left: 55px;
}

.certInfoView .name {
  font-size: 3em;
  font-weight: bold;
  margin-bottom: 2%;
}

.certInfoView .courseName {
  font-size: 1.8em;
  font-weight: bold;
  margin-top: 3%;
  word-wrap: break-word;
}

.certInfoView .completionDate,
.certInfoView .score {
  font-size: 1em;
  margin-left: 7%;
  max-width: calc(50% + 10px);
  display: inline-block;
  align-items: first baseline;
}

.certInfoView .fillInValue {
  line-height: 1.5em;
  font-size: 2em;
  font-weight: bold;
  height: 35px;
}

.certInfoView .header ~ h1,
.certInfoView .header ~ .h1 {
  font-size: 3vh !important;
}

.certInfoView .header .seperator {
  border-bottom: 3px solid #000;
  width: 90%;
  margin: 0 auto;
  height: 2%;
}

.certInfoView .fillInValue ~ .seperator {
  border-bottom: 2px solid grey;
  max-width: 70%;
  margin-left: 55px;
}

.certSuccessfulBg {
  width: 100%;
  height: 400px;
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
  height: 100%;
  font-family: 'Verdana', 'Arial', 'sans-serif';
}

.certificateContainer .holder {
  width: 100%;
  margin-top: 20px;
  height: 100%;
}

.certificateContainer .certSuccessfulBg .messageText {
  display: flex;
  font-weight: bold;
  font-size: 2.5em;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 60px;
  font-family: 'Verdana', 'Arial', 'sans-serif';
}

.certificateView {
  padding-top: 25px;
  display: flex;
  flex-direction: row-reverse;
  align-items: self-end;
}

.assignmentsHeader {
  margin: 0 auto !important;
}

.certSuccessfulBg div .buttons {
  display: flex;
  margin-top: 20px;
  padding-left: 15px;
}

.certSuccessfulBg div button {
  border: solid black 3px;
  font-weight: bold;
  background-color: #fff !important;
  color: #000 !important;
  margin-right: 1%;
  max-width: 200px;
  min-width: 130px;
  width: auto;
  display: flex;
  flex-direction: column;
  font-family: inherit;
  padding: 0;
}

.assignmentsHeader > h2 {
  padding-left: 0px !important;
  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';
  text-wrap: nowrap;
}

canvas {
  width: 100% !important;
  height: 100% !important;
  position: relative;
  display: block;
  padding: 0;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/courses/certificate.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,yDAAyD;EACzD,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;AACX","sourcesContent":[".course .certHolder {\n  padding-top: 45px;\n}\n\n.course .certHolder .col-md-12 {\n  background-color: #1eabe3;\n  height: 400px;\n  margin-bottom: 300px;\n}\n\n.course .certHolder .col-md-12 .col-md-4 {\n  margin-top: 120px;\n}\n\n.course .certHolder .col-md-12 .col-md-4 h2 {\n  color: #fff;\n  font-weight: bold;\n}\n\n.certInfo {\n  border: 7px solid #000;\n  float: right;\n  margin: 15px 0px;\n  padding: 0px;\n  position: relative;\n}\n\n.certInfo img {\n  width: 100%;\n}\n\n.certInfo span {\n  position: absolute;\n}\n\n.certInfo .name {\n  color: #228fc3;\n  font-size: 45px;\n  left: 0px;\n  text-align: center;\n  top: 39%;\n  width: 100%;\n}\n\n.certInfo .courseName {\n  font-size: 20px;\n  left: 0px;\n  text-align: center;\n  top: 55%;\n  width: 100%;\n}\n\n.certInfo .completionDate {\n  width: 42%;\n  bottom: 22%;\n  color: #228fc3;\n  font-size: 30px;\n  font-weight: 700;\n  text-align: center;\n  left: 0px;\n}\n\n.certInfo .score {\n  text-align: center;\n  bottom: 20%;\n  color: #228fc3;\n  font-size: 60px;\n  font-style: normal;\n  right: 0px;\n  width: 42%;\n}\n\n.courseCertNMLS .name {\n  font-size: 20px !important;\n  top: 82% !important;\n}\n\n.courseCertNMLS .courseName {\n  font-size: 30px !important;\n  top: 54% !important;\n  color: #228fc3;\n}\n\n.courseCertNMLS .completionDate {\n  font-size: 20px !important;\n  top: 82% !important;\n  font-weight: normal;\n}\n\n.courseCertNMLS .nmlsID {\n  font-size: 20px;\n  top: 82%;\n  color: #228fc3;\n  left: 250px;\n  text-align: center;\n  width: 100%;\n}\n\n.courseCertNMLS .courseCode {\n  font-size: 20px;\n  top: 70%;\n  color: #228fc3;\n  left: 0px;\n  text-align: center;\n  width: 100%;\n}\n\n.certInfoView {\n  color: #000;\n  max-width: 1500px;\n}\n\n.certInfoView .header {\n  margin: 2% auto 10% auto;\n}\n\n.certInfoView .seperator ~ .description {\n  font-size: 0.9em;\n  text-align: left;\n  margin-left: 55px;\n}\n\n.certInfoView .name {\n  font-size: 3em;\n  font-weight: bold;\n  margin-bottom: 2%;\n}\n\n.certInfoView .courseName {\n  font-size: 1.8em;\n  font-weight: bold;\n  margin-top: 3%;\n  word-wrap: break-word;\n}\n\n.certInfoView .completionDate,\n.certInfoView .score {\n  font-size: 1em;\n  margin-left: 7%;\n  max-width: calc(50% + 10px);\n  display: inline-block;\n  align-items: first baseline;\n}\n\n.certInfoView .fillInValue {\n  line-height: 1.5em;\n  font-size: 2em;\n  font-weight: bold;\n  height: 35px;\n}\n\n.certInfoView .header ~ h1,\n.certInfoView .header ~ .h1 {\n  font-size: 3vh !important;\n}\n\n.certInfoView .header .seperator {\n  border-bottom: 3px solid #000;\n  width: 90%;\n  margin: 0 auto;\n  height: 2%;\n}\n\n.certInfoView .fillInValue ~ .seperator {\n  border-bottom: 2px solid grey;\n  max-width: 70%;\n  margin-left: 55px;\n}\n\n.certSuccessfulBg {\n  width: 100%;\n  height: 400px;\n  margin: 10px 0;\n  display: flex;\n  justify-content: flex-end;\n  height: 100%;\n  font-family: 'Verdana', 'Arial', 'sans-serif';\n}\n\n.certificateContainer .holder {\n  width: 100%;\n  margin-top: 20px;\n  height: 100%;\n}\n\n.certificateContainer .certSuccessfulBg .messageText {\n  display: flex;\n  font-weight: bold;\n  font-size: 2.5em;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding-bottom: 60px;\n  font-family: 'Verdana', 'Arial', 'sans-serif';\n}\n\n.certificateView {\n  padding-top: 25px;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: self-end;\n}\n\n.assignmentsHeader {\n  margin: 0 auto !important;\n}\n\n.certSuccessfulBg div .buttons {\n  display: flex;\n  margin-top: 20px;\n  padding-left: 15px;\n}\n\n.certSuccessfulBg div button {\n  border: solid black 3px;\n  font-weight: bold;\n  background-color: #fff !important;\n  color: #000 !important;\n  margin-right: 1%;\n  max-width: 200px;\n  min-width: 130px;\n  width: auto;\n  display: flex;\n  flex-direction: column;\n  font-family: inherit;\n  padding: 0;\n}\n\n.assignmentsHeader > h2 {\n  padding-left: 0px !important;\n  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';\n  text-wrap: nowrap;\n}\n\ncanvas {\n  width: 100% !important;\n  height: 100% !important;\n  position: relative;\n  display: block;\n  padding: 0;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
